import React, { useEffect, useState } from "react";
import { Plus, Eye, Edit2, Trash2, Clock, X } from "lucide-react";
import Modal from "../../components/ui/Modal";
import AccountMeeting from "./AccounctMeeting";
import MeetingForms from "../meetings/MeetingForms";
import { useSelector } from "react-redux";
import meetingApi from "../../api/meetingApi";
import MeetingTab from "../../components/meetings/MeetingTab";
import { getPriorityColor, getStatusColor } from "../../utils/colors";
import { toast } from "react-toastify";
import { confirmSubmit } from "../../utils/confirmSubmit";

const MeetingsTab = ({ selectedClientData,onRefreshAccounts }) => {
  const [showViewMeeting,  setShowViewMeeting] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState(null);
const [meetingModal  , setMeetingModal] = useState(false)
    const token = useSelector((state) => state.auth.access_token);
  const meetings = selectedClientData?.meetings ?? [];

  const [showCreateTask, setShowCreateTask] = useState(false);
    const [taskId, setTaskId] = useState(null);
    const [isLoader, setIsLoader] = useState(false);
  
    const [formData, setFormData] = useState({
            meetingType: "",
            meetingDate: "",
            presentMembers: "",
            noticeIssueDate: "",
            agenda: "",
          });
  
  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    return isNaN(date.getTime()) ? "Invalid Date" : date.toLocaleDateString();
  };

  const formatTime = (dateStr) => {
    if (!dateStr) return "--:--";
    const date = new Date(dateStr);
    return isNaN(date.getTime())
      ? ""
      : date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
  };

  const handleView = (meeting) => {
    setSelectedMeeting(meeting);
    setShowViewMeeting(true);
  };

  const handleEdit = (meeting) => {
    setMeetingModal(true)
    sessionStorage.setItem("meetingData", JSON.stringify(meeting))
  };

  const handleDelete = async (meetingId) => {
 const confirmed = await confirmSubmit({
           title: "Confirm meeting delete",
           text: "Are you sure you want to delete this meeting?",
           confirmText: "Submit",
         });
       if (!confirmed) return;

  try {
    await meetingApi.deleteMeeting(selectedClientData.id, meetingId, token);

    const storedMeeting = sessionStorage.getItem("meetingData");
    if (storedMeeting) {
      const m = JSON.parse(storedMeeting);
      if (m?.id === meetingId) {
        sessionStorage.removeItem("meetingData");
      }
    }

    onRefreshAccounts?.();
  } catch (error) {
    console.error("Failed to delete meeting", error);
  }
};

 const handleSubmit = async () => {
    try {
      setIsLoader(true);
      if (taskId) {
        await meetingApi.updateMeeting(
          selectedClientData?.id,
          taskId,
          formData,
          token
        );
        toast.success("Meeting updated successfully");
        setIsLoader(false);
        setFormData({
            meetingType: "",
            meetingDate: "",
            presentMembers: "",
            noticeIssueDate: "",
            agenda: "",
          });
          setShowCreateTask(false);
          setTaskId(null);
      } else {
        await meetingApi.createMeeting(selectedClientData?.id, formData, token);
        toast.success("Meeting created successfully");
        setIsLoader(false);
        setFormData({
            meetingType: "",
            meetingDate: "",
            presentMembers: "",
            noticeIssueDate: "",
            agenda: "",
          });
          setShowCreateTask(false);
          setTaskId(null);
      }

      onRefreshAccounts?.();
    } catch (error) {
      setIsLoader(false);
      console.error(error);
      toast.error("Failed to save meeting");
    }
  };


  return (
    <div className="space-y-1">
      <MeetingTab
          allTasks={meetings}
          getStatusColor={getStatusColor}
          getPriorityColor={getPriorityColor}
          onRefreshAccounts={onRefreshAccounts}
          workflowDropdown={[]}
          formData={formData}
          isLoader={isLoader}
          showCreateTask={showCreateTask}
          setShowCreateTask={setShowCreateTask}
          setFormData={setFormData}
          handleSubmit={handleSubmit}
          heading={"All Meetings"}
          type={"meeting"}
          handleDeleteTask={handleDelete}
          taskId={taskId} 
          setTaskId={setTaskId}
      />
      {/* <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-6 py-1">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-lg font-semibold text-gray-900">Client Meetings</h3>
          <button
  onClick={() => {
    sessionStorage.removeItem("meetingData"); 
    setMeetingModal(true);                     
  }}
  className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
>
  <Plus className="h-4 w-4" />
  <span>Add Meeting</span>
</button>

        </div>

        {meetings.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Meeting Type
                  </th>
                  <th className="px-6 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Participants
                  </th>
                  <th className="px-6 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Date
                  </th>
                  <th className="px-6 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Time
                  </th>
                  <th className="px-6 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody className="bg-white divide-y divide-gray-200">
                {meetings.map((meeting) => (
                  <tr key={meeting?.id} className="hover:bg-gray-50">
                    <td className="px-6 py-2 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-900">
                        {(meeting?.meetingType ?? "Meeting").replace("_", " ")}
                      </div>
                    </td>

                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-900">
                      {meeting?.presentMembers ?? "N/A"}
                    </td>

                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-900">
                      {formatDate(meeting?.meetingDate)}
                    </td>

                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-900">
                      {formatTime(meeting?.meetingDate)}
                    </td>

                    <td className="px-6 py-2 whitespace-nowrap text-sm font-medium">
                      <div className="flex space-x-2">
                        <button
                          onClick={() => handleView(meeting)}
                          className="text-blue-600 hover:text-blue-900"
                        >
                          <Eye className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => handleEdit(meeting)}
                          className="text-gray-600 hover:text-gray-900"
                        >
                          <Edit2 className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => handleDelete(meeting?.id)}
                          className="text-red-600 hover:text-red-900"
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-8">
            <Clock className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <h4 className="text-lg font-medium text-gray-900 mb-2">No Meetings</h4>
            <p className="text-gray-600 mb-4">
              No meetings have been scheduled for this client yet.
            </p>
            <button onClick ={()=>setMeetingModal(true)} className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">
              Create First Meeting
            </button>
          </div>
        )}
      </div> */}

      {/* {showViewMeeting && selectedMeeting && (
       <Modal isOpen={showViewMeeting} title="Meeting Details" onClose={() => setShowViewMeeting(false)}>
  <div className="text-xs antialiased">
    <div className="flex items-center justify-between mb-2 border-b border-gray-100">
      <div className="flex items-center gap-2">
        <span className="bg-primary text-white px-1.5 py-0.5 rounded font-bold uppercase tracking-wider text-[10px] border border-indigo-100">
          {(selectedMeeting?.meetingType ?? "Meeting").replace("_", " ")}
        </span>

      </div>
      <div className="text-right leading-tight">
        <div className="font-medium text-gray-900">{formatDate(selectedMeeting?.meetingDate)}</div>
        <div className="text-gray-400 text-[10px] uppercase font-semibold">{formatTime(selectedMeeting?.meetingDate)}</div>
      </div>
    </div>

    <div className="grid grid-cols-3 gap-x-4 gap-y-3 mb-4">
      <div className="col-span-2">
        <span className="block text-gray-400 font-medium mb-1 uppercase text-[10px]">Participants</span>
        <div className="flex flex-wrap gap-1">
          {selectedMeeting?.presentMembers?.split(',').map((name, i) => (
            <span key={i} className="px-1.5 py-0.5 bg-gray-100 text-gray-700 rounded border border-gray-200">
              {name.trim()}
            </span>
          )) || "N/A"}
        </div>
      </div>
      <div>
        <span className="block text-gray-400 font-medium mb-1 uppercase text-[10px]">Notice Issued</span>
        <span className="text-gray-600 mr-2">{formatDate(selectedMeeting?.noticeIssueDate)}</span>
        <span className="text-gray-600">{formatTime(selectedMeeting?.noticeIssueDate)}</span>

      </div>
    </div>

    <div className="bg-gray-50/50 p-2 rounded border border-dashed border-gray-200">
      <span className="block text-gray-400 font-medium mb-0.5 uppercase text-[10px]">Agenda Notes</span>
      <p className="text-gray-500 leading-normal italic">
        {selectedMeeting?.agenda}
      </p>
    </div>
  </div>
</Modal>
      )} */}


        {/* <Modal
  isOpen={meetingModal}
  title="Create Meeting"
  onClose={() => setMeetingModal(false)}
>
  <MeetingForms onSuccess={() => setMeetingModal(false)} accountId={selectedClientData.id} onRefreshAccounts={onRefreshAccounts}/>
</Modal> */}
    </div>
  );
};

export default MeetingsTab;
